import {EntityWithId} from "../../types/baseEntities";


export const removeDuplicatesById = (entities: EntityWithId<number>[]) => {
    return entities.filter((entity, index, self) =>
        self.findIndex(e => e.id === entity.id) === index);
}

export const arrayChunks = (array: any[], chunk_size: number) => Array(Math.ceil(array.length / chunk_size)).fill(0).map((_, index) => index * chunk_size).map(begin => array.slice(begin, begin + chunk_size))